import React from 'react'

import { B2, H5, Stack } from '@zet/design-system'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'

import { LinkBrokenSvg } from '../../assets/svg/linkBroken'

export const LinkBroken = () => {
  const message =
    APP_NAME === 'my-teams'
      ? i18n.t('linkBroken.somethingWentWrong')
      : i18n.t('linkBroken.contactAgentLinkBroken')

  return (
    <Stack className="flex-1 items-center justify-center bg-white">
      <LinkBrokenSvg />
      <H5 className="mb-4 mt-2">{i18n.t('linkBroken.title')}</H5>
      <B2>{message}</B2>
    </Stack>
  )
}
